import { type ILoanRepurchase, type ILoanSaleTrade, LOAN_TRADE_TYPES } from './types'

const tradeTypeOptions = LOAN_TRADE_TYPES.reduce(
  (acc, type) => ({ ...acc, [type]: type }),
  {} as Record<string, string>,
)

const settledOptions = {
  false: 'No',
  true: 'Yes',
}

export const loanSaleTradeInputs = (
  form: Partial<ILoanSaleTrade>,
  loanOptions: Record<string, string>,
): Record<string, any> => ({
  loanId: {
    inputType: 'select',
    title: 'Loan ID',
    options: loanOptions,
    value: form.loanId,
    hasDefaultOption: true,
    defaultOptionText: 'Select',
    required: true,
  },
  tradeType: {
    inputType: 'select',
    title: 'Trade Type',
    options: tradeTypeOptions,
    value: form.tradeType,
    hasDefaultOption: false,
  },
  settled: {
    inputType: 'select',
    title: 'Settled?',
    options: settledOptions,
    value: String(form.settled ?? false),
    hasDefaultOption: false,
  },
  srp: { inputType: 'text', type: 'number', title: 'SRP', value: form.srp },
})

export const loanRepurchaseInputs = (
  form: Partial<ILoanRepurchase>,
  loanOptions: Record<string, string>,
): Record<string, any> => ({
  loanId: {
    inputType: 'select',
    title: 'Loan',
    options: loanOptions,
    value: form.loanId,
    hasDefaultOption: true,
    defaultOptionText: 'Select',
    required: true,
  },
  repurchasePrice: { inputType: 'text', type: 'number', title: 'Repurchase Price', value: form.repurchasePrice },
  reason: { inputType: 'textarea', title: 'Reason', value: form.reason, span: 'full' },
})
